// src/intake/LoomEmbed.tsx
// ─────────────────────────────────────────────────────────────────────────────
// Brief 23 — Loom video embed with placeholder fallback
// ─────────────────────────────────────────────────────────────────────────────

import React from 'react';

interface LoomEmbedProps {
  url: string;
  title: string;
}

export default function LoomEmbed({ url, title }: LoomEmbedProps) {
  if (url.includes('PLACEHOLDER')) {
    return (
      <div
        style={{
          background: 'rgba(255,255,255,0.1)',
          border: '2px dashed rgba(255,255,255,0.3)',
          borderRadius: 12,
          padding: 48,
          textAlign: 'center',
          color: 'rgba(255,255,255,0.6)',
          aspectRatio: '16/9',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <p style={{ fontSize: 16, margin: 0 }}>
          Video coming soon — click Continue to proceed.
        </p>
      </div>
    );
  }

  return (
    <iframe
      src={url}
      title={title}
      allow="autoplay; fullscreen"
      allowFullScreen
      style={{
        width: '100%',
        aspectRatio: '16/9',
        borderRadius: 12,
        border: 'none',
        background: '#000',
      }}
    />
  );
}
